import axios from "axios";
import {Dispatch} from "redux";
import {ActionType} from "../action_type";
import {Action} from "../actions/userInfoAction";

export const fetchUserInfo = (formData : any) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.FETCH_USERINFO
    })

    try {
      // console.log(formData);
      const {data}  = await axios.post(`${process.env.REACT_APP_BASE_URL_FS}/public/v1/fs/users/registration/finalize` , formData , {
        params : {
          lang : 'fa'
        }
      });
      // console.log(data);
      console.log('dispatched');
      dispatch({
        type : ActionType.FETCH_USERINFO_SUCCESS,
        payload : data
      })
    } catch (err : any) {
      dispatch({
        type: ActionType.FETCH_USERINFO_ERROR,
        payload: err.message
      })
    }
  }
}

